import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class RadioComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentRadio | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.defaultValue = settings?.defaultValue ?? '';
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.fieldSet = settings?.fieldSet ?? false;
		this.inline = settings?.inline ?? false;
		this.input = true;
		this.inputType = settings?.inputType ?? 'radio';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.protected = settings?.protected ?? false;
		this.values = settings?.values ?? [];
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
	}
}
